import { render, staticRenderFns } from "./ChargerTab.vue?vue&type=template&id=5755aff3"
import script from "./ChargerTab.vue?vue&type=script&lang=js"
export * from "./ChargerTab.vue?vue&type=script&lang=js"
import style0 from "./ChargerTab.vue?vue&type=style&index=0&id=5755aff3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports